import { render, staticRenderFns } from "./puas.vue?vue&type=template&id=e19b1876&scoped=true&"
import script from "./puas.vue?vue&type=script&lang=js&"
export * from "./puas.vue?vue&type=script&lang=js&"
import style0 from "./puas.vue?vue&type=style&index=0&id=e19b1876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19b1876",
  null
  
)

export default component.exports